import React, { useState } from "react";

const ProductPerformanceFilters = ({ onSearch }) => {
  const [crmProductId, setCrmProductId] = useState("");
  const [crmShareClassGuid, setCrmShareClassGuid] = useState("");
  const [category, setCategory] = useState("");
  const [quarter, setQuarter] = useState("");
  const [status, setStatus] = useState("");

  const handleCrmProductIdChange = (e) => {
    const value = e.target.value;
    setCrmProductId(value);
  };
  const handleShareClassGuidChange = (e) => {
    const value = e.target.value;
    setCrmShareClassGuid(value);
  };
  const handleCAtegoryChange = (e) => {
    const value = e.target.value;
    setCategory(value);
  };
  const handleQuarterChange = (e) => {
    const value = e.target.value;
    setQuarter(value);
  };
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
  };

  const handleSearchClick = () => {
    onSearch({ crmProductId, crmShareClassGuid, category, quarter, status });
  };
  //   const handleDateFromChange = (e) => {
  //     const value = e.target.value;
  //     setFrom(value);
  //   };
  //   const handleDateToChange = (e) => {
  //     const value = e.target.value;
  //     setTo(value);
  //   };

  return (
    <div className=" mb-3 p-3 bg-body rounded shadow-sm">
      <div className="row">
        <div className="col-sm-6">
          <input
            type="text"
            placeholder="Search by CRM product ID"
            className="form-control floating"
            value={crmProductId}
            onChange={handleCrmProductIdChange}
            width={200}
          />
        </div>
        <div className="col-sm-6">
          <input
            type="text"
            placeholder="Search by Shareclass GUID"
            className="form-control floating"
            value={crmShareClassGuid}
            onChange={handleShareClassGuidChange}
            width={200}
          />
        </div>
        <div className="col-sm-6">
          {/* <select
            className="form-control"
            value={category}
            onChange={handleCAtegoryChange}
            width={150}
          >
            <option value="">Select Role</option>
            <option value="broker">Broker</option>
            <option value="user">User</option>
          </select> */}
          <input
            type="text"
            placeholder="Search by Category"
            className="form-control floating"
            value={category}
            onChange={handleCAtegoryChange}
            width={200}
          />
        </div>
        <div className="col-sm-2">
          {/* <label>From Date:</label> */}
          <input
            type="number"
            className="form-control"
            placeholder="Search by Quarter"
            value={quarter}
            onChange={handleQuarterChange}
            style={{ width: 200 }}
          />
        </div>
        <div className="col-sm-4">
          {/* <label>To Date:</label> */}
          {/* <input
            type="text"
            placeholder="Search by Status"
            className="form-control"
            value={status}
            onChange={handleStatusChange}
            style={{ width: 200 }}
          /> */}
          <select
            className="form-control"
            value={status}
            onChange={handleStatusChange}
            width={150}
          >
            <option value="">Select Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">In Active</option>
          </select>
        </div>
        <div className="col-sm-3 col-md-2">
          <button className="btn btn-primary" onClick={handleSearchClick}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductPerformanceFilters;
